import * as institutionLoginsActions from './institutionLoginsActions';
import { institutionLoginsReducer } from './institutionLoginsReducer';
import institutionLoginsSagas from './institutionLoginsSagas';
import * as institutionLoginsSelectors from './institutionLoginsSelectors';
import * as institutionLoginsTransformers from './institutionLoginsTransformers';
import * as institutionLoginsTypes from './institutionLoginsTypes';
import * as institutionLoginsUtils from './institutionLoginsUtils';

const { INSTITUTION_LOGINS_REDUCER_KEY } = institutionLoginsTypes;

const INSTITUTION_LOGINS_VERSION_NUMBER = 3;

export {
  INSTITUTION_LOGINS_REDUCER_KEY,
  INSTITUTION_LOGINS_VERSION_NUMBER,
  institutionLoginsActions,
  institutionLoginsReducer,
  institutionLoginsSagas,
  institutionLoginsSelectors,
  institutionLoginsTypes,
  institutionLoginsTransformers,
  institutionLoginsUtils,
};
